<template>
     <div class="btn">
            <p :class="{'yes': tabType == 'day' }" @click="changeTab('day')">今日</p>
            <p :class="{'yes': tabType == 'month' }" @click="changeTab('month')">近30日</p>
            <p :class="{'yes': tabType == 'year' }" @click="changeTab('year')">近半年</p>
        </div>
</template>
<script>
export default {
    data () {
    return {
      tabType:'month',
    }
  },
  methods: {
      changeTab (type) {
      this.tabType = type
      this.$emit('click',type)
    },
  }
}
</script>
<style scoped>
.btn {
    display: flex;
    width:180px;
    height: 30px;
    border: 1px solid #5483D2;
    color: #737171;
    font-size: 12px;
    margin: auto;
    border-radius: 2px;
    border-right: none;
}
.btn p{
    justify-content:space-between;
    width: 60px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border-right: 1px solid #5483D2;
  }
   .yes{
    background: #5483D2;
    color: #fff;
  }
</style>


// WEBPACK FOOTER //
// src/components/performance/components/btn.vue